class SkeletonLoader extends HTMLElement {
	static observedAttributes = ["skeleton-count", "variant"];

	#skeletonCount = 10;
	#variant = "";

	/**
	 * Creates an instance of SkeletonLoader and initializes the skeleton count.
	 */
	constructor() {
		super();

		this.#skeletonCount = Number(this.getAttribute("skeleton-count")) || 10;
		this.#variant = this.getAttribute("variant") || "";
	}

	/**
	 * Returns the HTML string for a single skeleton placeholder item.
	 * @returns {string} The HTML for a skeleton placeholder.
	 */
	#getPlaceholderItem() {
		// TODO: Revisit template source if skeleton variants grow. Keep inline for
		// now to preserve web component encapsulation; consider DOM/Twig templates
		// only if we need SSR/no-JS fallback placeholders or significantly larger markup.
		if (this.#variant === "card") {
			return `
    <article class="SkeletonLoader-item SkeletonLoader-itemCard">
      <div class="SkeletonLoader-cardMedia SkeletonLoader-shimmerLoadingPlaceholder"></div>
      <div class="SkeletonLoader-cardLine SkeletonLoader-shimmerLoadingPlaceholder"></div>
      <div class="SkeletonLoader-cardLine SkeletonLoader-cardLineShort SkeletonLoader-shimmerLoadingPlaceholder"></div>
    </article>
  `;
		}

		return `
    <div class="SkeletonLoader-item">
      <div class="SkeletonLoader-boxDefault SkeletonLoader-shimmerLoadingPlaceholder"></div>
      <div class="SkeletonLoader-boxThin SkeletonLoader-shimmerLoadingPlaceholder"></div>
    </div>
  `;
	}

	/**
	 * Returns an array of skeleton placeholder HTML strings based on the skeleton count.
	 * @returns {string[]} Array of skeleton placeholder HTML strings.
	 */
	#getPlaceholderItems() {
		return Array.from({ length: this.#skeletonCount }, () =>
			this.#getPlaceholderItem(),
		);
	}

	/**
	 * Renders the skeleton placeholder items inside the component.
	 * @private
	 */
	#render() {
		this.innerHTML = this.#getPlaceholderItems().join("");
	}

	/**
	 * Called when an observed attribute has changed.
	 * @param {string} name - The name of the attribute that changed.
	 * @param {string | null} _oldValue - The old value of the attribute.
	 * @param {string | null} newValue - The new value of the attribute.
	 */
	attributeChangedCallback(name, _oldValue, newValue) {
		if (name === "skeleton-count") {
			this.#skeletonCount = Number(newValue) || 10;
			this.#render();
		}
		if (name === "variant") {
			this.#variant = newValue || "";
			this.#render();
		}
	}

	/**
	 * Called when the element is inserted into the DOM.
	 * @private
	 */
	connectedCallback() {
		this.#render();
	}
}

customElements.define("skeleton-loader", SkeletonLoader);
